import axios from "axios";

const elements = {
  triggers: document.querySelectorAll(".js-collapsible-trigger"),
  inputs: document.querySelectorAll(".js-input"),
  customerEmail: document.querySelector(".js-customer-email"),
  retrievalEmail: document.querySelector(".js-retrieval-email"),
  retrievalRef: document.querySelector(".js-retrieval-ref"),
  saveBtn: document.querySelector(".js-save-btn"),
  retrieveForm: document.querySelector(".js-retrieve-form"),
  submitBtn: document.querySelector(".js-submit-btn"),
  formDetailsBtn: document.querySelector(".js-form-details-btn"),
  accordionPanels: document.querySelectorAll(".js-accordion-trigger"),
  accordionBodys: document.querySelectorAll(".js-accordion-expand"),
  successContainer: document.querySelector('.js-success-message'),
  errorContainer: document.querySelector('.js-error-message'),
  formRefIds: document.querySelectorAll('.js-form-reference-id'),
  formType: document.querySelector('.js-form-type'),
  formToken: document.querySelector('.js-form-token'),
  form: document.querySelector('.organisation-form'),
  addEntryBtn: document.querySelector('.js-add-entry-btn'),
  entriesContainer: document.querySelector('.js-entries-container'),
  entry: document.querySelector('.js-entry'),
  completedAccordion: document.querySelector('#completed-forms-accordion'),
  incompletedAccordion: document.querySelector('#incompleted-forms-accordion'),
  prevSubmissionsActionLinks: document.querySelectorAll('.c-accordion-list__action-link')
};

let formId = null;

function compileCustomerDetails(e) {
  e.preventDefault();

  collectCustomerDetails(successMessage);
}

function collectCustomerDetails(onSuccess) {
  let data = [];

  document.querySelectorAll(".js-input").forEach((input) => {
    if(input.type === 'radio'){
      if(input.checked){
      data = addToArray(data, input);
      }
    }
    else{
      data = addToArray(data, input);
    }
  });
  saveCustomerDetails(data, onSuccess);
}

function addToArray(arr, input){
  return [...arr, {
    name: input.id,
    value: input.value
  }];
}

function saveCustomerDetails(data, onSuccess) {
  if (elements.customerEmail.checkValidity()) {
    const endpoint = "/ytlapi/organisationformsaveapi/post";
    axios
      .post(endpoint, {
        token: formId,
        inputs: data,
      })
      .then((response) => {
        formId = response.data;
        elements.formToken.value = response.data;

        onSuccess(formId);
      })
      .catch(errorMessage);
  }
}

function successMessage(id) {
  if (id !== null || id !== undefined) {
    elements.successContainer.style.display = "block";
    elements.successContainer.scrollIntoView();
    elements.formRefIds.forEach((element) => element.textContent = id);
    return;
  }
}

function errorMessage(error) {
  elements.errorContainer.style.display = "block";
  elements.errorContainer.scrollIntoView();
  return;
}

function challengeResponse(response, email) {
  if (response.data.isComplete) {
    handleDownload(email);
  }
  else {
    updateFields(response);
  }
}

function handleDownload(email) {
  const endpoint = "/ytlapi/organisationformretrievefileapi/post";
  const formType = elements.formType.value;

  axios
    .post(endpoint, {
      email: email,
      token: formId,
      formType: formType
    }, { responseType: 'blob' })
    .then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'form.pdf');
      document.body.appendChild(link);
      link.click();
    })
    .catch(errorMessage);
}

function updateFields(response) {
  const data = response.data.fields;
  elements.inputs.forEach((el) => {
    data.forEach((item) => {
      if (item.name === el.id) {
        el.value = item.value;
      }
    });
  });
}

function getSingularForm(e){
  e.preventDefault();

  const email = elements.retrievalEmail.value;
  formId = elements.retrievalRef.value;

  getCustomerDetails(email);
}

function getOrganisationForm(e){
  e.preventDefault();

  const email = e.target.getAttribute("data-email");
  var orgFormId = e.target.getAttribute("data-reference");

  formId = orgFormId;

  getCustomerDetails(email);
}

function getCustomerDetails(email) {
  const endpoint = "/ytlapi/organisationformretrieveapi/post";
  const formType = elements.formType.value;
  
  if (typeof elements.formToken !== "undefined") {
    elements.formToken.value = formId;
  }

  axios
    .post(endpoint, {
      email: email,
      token: formId,
      formType: formType
    })
    .then(function(response){
      challengeResponse(response, email)})
    .catch(errorMessage);

  if (elements.accordionPanels.length > 0) {
    expandAccordions();
  }
}

function postForm() {
  elements.form.submit();
  return;
}

function submitForm(e) {
  e.preventDefault();
  collectCustomerDetails(postForm);
}

function expandAccordions() {
  elements.accordionPanels.forEach((panel) => {
    panel.setAttribute("aria-expanded", "true");
    panel.classList.add("is-active");
  });
  elements.accordionBodys.forEach((body) => {
    body.removeAttribute("hidden");
  });
}

function addEntry() {
  const currentEntriesCount = document.querySelectorAll('.js-entry').length;

  if(currentEntriesCount === 3){
    elements.addEntryBtn.style.display = "none";
  }

  const newEntry = elements.entry.cloneNode(true);
  const allNumbersExp = /\d{1,2}/g;
  const id = "id";
  const name = "name";

  newEntry.querySelectorAll('.form-control').forEach(element => {
    const elementId = element.getAttribute(id).replace(allNumbersExp, currentEntriesCount);
    const elementName = element.getAttribute(name).replace(allNumbersExp, currentEntriesCount);

    element.setAttribute(id, elementId);
    element.setAttribute(name, elementName);
    element.value = "";
  });

  elements.entriesContainer.appendChild(newEntry);
}

// 1. Bring in static Accordions (Complete, Incomplete) or build programmatically. [x]
// 2. Fetch list of forms [x]
// 3. Group data by form completion status []
// 4. Render data in to specific accordion []
// 4. a) For each item in group, render item with styles and action link []
// 4. b) If complete? Action link should display 'Edit' for link text []
// 4. c) If incomplete? Action link should display 'Download' for link text []
// 5. On Action link click dispatch the getSingularForm function with item credentials. []

// Potential Issues
// 1. Elements.accordionPanels could interfere with new static accordions for incomplete and complete

function init() {
  if (elements.retrieveForm) {
    elements.formDetailsBtn.addEventListener("click", getSingularForm);
  }

  if (elements.saveBtn) {
    elements.saveBtn.addEventListener("click", compileCustomerDetails);
  }

  if (elements.submitBtn) {
    elements.submitBtn.addEventListener("click", submitForm);
  }

  if (elements.formToken && elements.formToken.value !== null && typeof elements.formToken.value !== "undefined") {
    formId = elements.formToken.value;
  }

  if(elements.prevSubmissionsActionLinks.length) {
    elements.prevSubmissionsActionLinks.forEach((link) => {
      link.addEventListener("click", getOrganisationForm);
    });
  }

  if (elements.triggers.length) {
    elements.triggers.forEach((trigger) => {
      const target = trigger.parentNode.querySelector(".js-collapsible-target");
      trigger.addEventListener("click", (e) => {
        e.preventDefault();
        trigger.style.display = "none";
        if (target.classList.contains("is-collapsed")) {
          target.style.maxHeight = `${target.scrollHeight}px`;
          target.classList.remove("is-collapsed");
        }
      });
    });
  }

  if (elements.addEntryBtn) {
    elements.addEntryBtn.addEventListener("click", addEntry);
  }
}

export default init;


// WEBPACK FOOTER //
// ./src/components/components/partnerhub/standard-form/bespoke-form.js